<template>
    <PageHeader :title="(moduleID) ? sprintf($t('pages.module.settings.subTitle'), [this.module.name ?? '']) : $t('pages.module.settings.subTitle')" back-to="/module"/>

    <el-form :model="form.data" ref="settingsForm">
        <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
            <div class="col-md-12" v-for="(item, itemIndex) in data" :key="itemIndex">

                <div class="card-setting" v-if="item.component?.type !== 'checkbox_group'">
                    <div class="card-setting-header">
                        <div>
                            <div>{{ item.title }}</div>
                            <small class="info" v-if="item.description">{{ item.description }}</small>
                        </div>

                        <el-tooltip :content="$t('pages.module.settings.tooltip.enabledSms')" placement="left">
                            <el-switch v-model="item.enabled" style="--el-switch-on-color: #4cff83; --el-switch-off-color: #ff4949" :active-value="1" :inactive-value="0" @change="changeStatus('NOTIFY_STATUS_CHANGED_ENABLED_SMS')"/>
                        </el-tooltip>
                    </div>

                    <div class="content">
                        <div class="richarea" contenteditable="true" :ref="'ed_'+itemIndex" @dragover.prevent
                             @input="variableContextValueSync(itemIndex, item)"
                             @click="saveRange(itemIndex)"
                             @keyup="saveRange(itemIndex)"
                             @dragstart="onEditorDragStart($event, itemIndex)"
                             @drop.prevent="onEditorDrop($event, itemIndex, item)"
                             @mousedown="onVariablePressStart($event, itemIndex, item)"
                             @mouseup="onVariablePressEnd"
                             @mouseleave="onVariablePressEnd"
                        >
                        </div>
                    </div>

                    <div class="variables" v-if="item.supported_variables?.length">
                        <div class="variable" v-for="(variable, vIndex) in item.supported_variables" :key="vIndex" draggable="true" @dragstart="onVariableDragStart($event, variable)" @click="addVariable(itemIndex, item, variable)">
                            {{ variable }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-6 mb-6 g-xl-9 mb-xl-9">
            <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-end w-100">
                    <button @click.prevent="onSubmit" :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="button">
                        <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                        <span v-if="form.loading" class="indicator-progress">
                            {{ $t("messages.wait") }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import PageHeader from "@/components/page-header/PageHeader.vue";

export default {
    name: "settings",
    components: {PageHeader},
    data() {
        return {
            tabModel: 'general',
            company: {},
            form: {
                loading: false,
                data: {
                    settings: []
                },
            },
            data: {},
            variableContext: {
                lastRange: {},
                draggingEl: null,
                draggingFrom: null,
                pressTimer: null,
                pressedVar: null
            }
        }
    },
    computed: {
        moduleID() {
            return Number(this.$route.params.id);
        },
        module() {
            return this.$store.getters['company/module/moduleDetail'](this.moduleID);
        }
    },
    created() {
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("pages.module.settings.title"), []);

        if ((this.moduleID && this.moduleID > 0) && this.module?.supported?.settings) {
            this.fetchSettings();
        } else {
            this.$router.push({
                path: "/module",
            });
        }
    },
    methods: {
        fetchSettings(moduleID = this.moduleID) {
            this.$store.dispatch("company/module/setting", {
                moduleID: moduleID
            }).then((res) => {
                let status = res.find(item => item.opt === 'NOTIFY_STATUS_CHANGED_ENABLED_SMS');
                status = status.value ?? status.default;

                this.data = res.map((item, index) => ({
                    ...item,
                    value: item.value ?? item.default,
                    enabled: status.find(item => item === 'STATUS_' + index) ? 1 : 0,
                }));

                this.form.data.settings = this.data.map(item => ({
                    opt: item.opt,
                    value: item.value
                }));
            });
        },
        onSubmit() {
            this.$refs.settingsForm.validate((valid) => {
                if (valid) {
                    this.form.loading = true;

                    if (this.moduleID) {
                        this.$store.dispatch('company/module/updateSetting', {
                            moduleID: this.moduleID,
                            settings: this.form.data.settings,
                        }).then((response) => {
                            if (response?.status) {
                                this.onResponse(response, () => {
                                    this.fetchSettings();
                                });
                            }

                            this.form.loading = false;
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        changeData(opt, data) {
            const index = this.form.data.settings.findIndex(item => item.opt === opt);

            if (index !== -1) {
                this.form.data.settings[index].value = data;
            } else {
                this.form.data.settings.push({
                    opt: opt,
                    value: data
                });
            }
        },
        changeStatus(parentOpt) {
            const enabledList = this.data
                .filter(item => item.enabled === 1)
                .map(item => {
                    const match = item.opt.match(/STATUS_\d+/);
                    return match ? match[0] : null;
                })
                .filter(Boolean);

            const index = this.form.data.settings.findIndex(
                item => item.opt === parentOpt
            );

            if (index !== -1) {
                this.form.data.settings[index].value = enabledList;
            } else {
                this.form.data.settings.push({
                    opt: parentOpt,
                    value: enabledList
                });
            }
        },
        resetForm() {
            this.form.data.settings = [];
            this.data = {};
        },
        _edRef(itemIndex) {
            const ref = this.$refs['ed_' + itemIndex];
            return Array.isArray(ref) ? ref[0] : ref;
        },
        variableContextInit(itemIndex, item) {
            const el = this._edRef(itemIndex);
            if (!el || document.activeElement === el) return;

            el.innerHTML = (item.value || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\{\{\s*([\w.-]+)\s*\}\}/g, (_, v) =>
                `<span class="variable active variable-in-editor" draggable="true" contenteditable="false" data-var="${v}">${v}</span>`
            ).replace(/\n/g, '<br>');
        },
        variableContextValueSync(itemIndex, item) {
            const el = this._edRef(itemIndex);
            if (!el) return;

            const c = el.cloneNode(true);
            c.querySelectorAll('.variable-in-editor').forEach(n => {
                const v = n.dataset.var || n.textContent || '';
                n.replaceWith(document.createTextNode(`{{ ${v} }}`));
            });

            item.value = c.innerText;
            this.changeData(item.opt, item.value);
        },
        saveRange(itemIndex) {
            const el = this._edRef(itemIndex);
            const sel = window.getSelection();
            if (!el || !sel || !sel.rangeCount || !el.contains(sel.anchorNode)) return;

            this.variableContext.lastRange[itemIndex] = sel.getRangeAt(0).cloneRange();
        },
        createSpan(variable) {
            const span = document.createElement('span');
            span.className = 'variable active variable-in-editor';
            span.contentEditable = 'false';
            span.draggable = true;
            span.dataset.var = variable;
            span.textContent = variable;
            return span;
        },
        addVariable(itemIndex, item, variable) {
            const el = this._edRef(itemIndex);
            if (!el) return;

            el.focus();
            const sel = window.getSelection();
            sel.removeAllRanges();

            sel.addRange(this.variableContext.lastRange[itemIndex] || (() => {
                const r = document.createRange();
                r.selectNodeContents(el);
                r.collapse(false);
                return r;
            })());

            const range = sel.getRangeAt(0);
            range.deleteContents();

            const span = this.createSpan(variable);

            range.insertNode(document.createTextNode(' '));
            range.insertNode(span);

            range.setStartAfter(span);
            range.collapse(true);

            sel.removeAllRanges();
            sel.addRange(range);
            this.variableContext.lastRange[itemIndex] = range.cloneRange();

            this.variableContextValueSync(itemIndex, item);
        },
        onVariableDragStart(e, variable) {
            e.dataTransfer.effectAllowed = 'copy';
            e.dataTransfer.setData('text/plain', variable);
        },
        onEditorDragStart(e, itemIndex) {
            this.onVariablePressEnd();

            const t = e.target;
            if (!t || !t.classList || !t.classList.contains('variable-in-editor')) return;

            this.variableContext.draggingEl = t;
            this.variableContext.draggingFrom = itemIndex;

            t.classList.add('dragging');

            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/x-var-move', '1');
        },
        onEditorDrop(e, itemIndex, item) {
            const el = this._edRef(itemIndex);
            if (!el) return;

            if (this.variableContext.draggingEl) {
                this.variableContext.draggingEl.classList.remove('dragging');
            }

            const target = e.target && e.target.nodeType === 3 ? e.target.parentElement : e.target;

            if (target && target.classList && target.classList.contains('variable-in-editor')) {
                if (e.dataTransfer.getData('text/x-var-move') && this.variableContext.draggingEl && this.variableContext.draggingFrom === itemIndex) {
                    if (this.variableContext.draggingEl !== target) {
                        const source = this.variableContext.draggingEl;
                        const sourceParent = source.parentNode;
                        const sourceNext = source.nextSibling;

                        const targetParent = target.parentNode;
                        const targetNext = target.nextSibling;

                        if (!sourceParent || !targetParent) return;

                        if (sourceNext === target) {
                            targetParent.insertBefore(source, targetNext);
                        } else if (targetNext === source) {
                            sourceParent.insertBefore(target, sourceNext);
                        } else {
                            sourceParent.insertBefore(target, sourceNext);
                            targetParent.insertBefore(source, targetNext);
                        }
                    }

                    this.variableContext.draggingEl = null;
                    this.variableContext.draggingFrom = null;
                } else {
                    const variable = e.dataTransfer.getData('text/plain');
                    if (!variable) return;
                    target.replaceWith(this.createSpan(variable));
                }

                this.variableContextValueSync(itemIndex, item);
                return;
            }

            el.focus();

            let range = null;
            if (document.caretRangeFromPoint) {
                range = document.caretRangeFromPoint(e.clientX, e.clientY);
            } else if (document.caretPositionFromPoint) {
                const p = document.caretPositionFromPoint(e.clientX, e.clientY);
                if (p) {
                    range = document.createRange();
                    range.setStart(p.offsetNode, p.offset);
                    range.collapse(true);
                }
            }

            if (!range || !el.contains(range.startContainer)) {
                range = document.createRange();
                range.selectNodeContents(el);
                range.collapse(false);
            }

            if (range.startContainer && range.startContainer.nodeType === 3) {
                const tn = range.startContainer;
                const text = tn.nodeValue || '';
                const off = range.startOffset;

                const isSpace = (ch) => ch === ' ' || ch === '\n' || ch === '\t';

                let L = off;
                while (L > 0 && !isSpace(text[L - 1])) {
                    L--;
                }

                let R = off;
                while (R < text.length && !isSpace(text[R])) {
                    R++;
                }

                const dL = off - L;
                const dR = R - off;
                const snap = (dL <= dR) ? L : R;

                range.setStart(tn, snap);
                range.collapse(true);
            }

            const sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);

            if (e.dataTransfer.getData('text/x-var-move') && this.variableContext.draggingEl && this.variableContext.draggingFrom === itemIndex) {
                range.insertNode(this.variableContext.draggingEl);
                this.variableContext.draggingEl = null;
                this.variableContext.draggingFrom = null;
            } else {
                const variable = e.dataTransfer.getData('text/plain');
                if (!variable) return;

                const span = this.createSpan(variable);

                range.insertNode(document.createTextNode(' '));
                range.insertNode(span);
            }

            range.collapse(false);
            sel.removeAllRanges();
            sel.addRange(range);
            this.variableContext.lastRange[itemIndex] = range.cloneRange();

            this.variableContextValueSync(itemIndex, item);
        },
        onVariablePressStart(e, itemIndex, item) {
            const target = e.target.nodeType === 3 ? e.target.parentElement : e.target;
            if (!target?.classList?.contains('variable-in-editor')) {
                return;
            }

            this.onVariablePressEnd();

            this.variableContext.pressedVar = target;
            const touch = e.touches?.[0] || e;
            this.pressStartX = touch.clientX;
            this.pressStartY = touch.clientY;

            this.pressMoveHandler = (ev) => {
                const currentTouch = ev.touches?.[0] || ev;
                const dx = Math.abs(currentTouch.clientX - this.pressStartX);
                const dy = Math.abs(currentTouch.clientY - this.pressStartY);

                if (dx > 8 || dy > 8) {
                    this.onVariablePressEnd();
                }
            };

            window.addEventListener('mousemove', this.pressMoveHandler, { passive: true });
            window.addEventListener('touchmove', this.pressMoveHandler, { passive: true });

            this.variableContext.pressTimer = setTimeout(() => {
                if (!this.variableContext.pressedVar) return;

                navigator.vibrate?.(30);
                this.variableContext.pressedVar.remove();
                this.variableContext.pressedVar = null;
                this.sync(itemIndex, item);
            }, 600);
        },
        onVariablePressEnd() {
            clearTimeout(this.variableContext.pressTimer);
            this.variableContext.pressTimer = null;
            this.variableContext.pressedVar = null;

            if (this.pressMoveHandler) {
                window.removeEventListener('mousemove', this.pressMoveHandler);
                window.removeEventListener('touchmove', this.pressMoveHandler);
                this.pressMoveHandler = null;
            }
        }
    },
    watch: {
        moduleID(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (!newValue) {
                    this.resetForm()
                }
            }
        },
        'data': {
            deep: true,
            handler(list) {
                this.$nextTick(() => {
                    (list || []).forEach((item, i) => {
                        if (item?.component?.type === 'textarea') this.variableContextInit(i, item);
                    });
                });
            }
        }
    }
}
</script>